import React from 'react';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckSquare, faWindowClose} from '@fortawesome/free-regular-svg-icons';
import {DATE_FORMAT, DATE_TIME_FORMAT} from './StringTools';
import Dollars from './Dollars';
import {Badge} from 'reactstrap';
import Checkbox from './Checkbox';

export const arrayFormatter = cell => {
    let string = '';
    cell.forEach((x, i) => {
        if (x.constructor.name === 'Object') {
            string += x.email;
        } else {
            string += x;
        }
        if (i !== cell.length - 1) {
            string += ', ';
        }
    });
    return string;
};

export const colorBlockFormatter = (cell, color, small = false) => {
    return (
        <div className='d-inline-block'>
            <span className={`color-block ${small ? 'thin' : ''}`} style={{backgroundColor: color}} />
            <span className='pb-2'>{cell}</span>
        </div>
    );
};
export const imageFormatter = (image, alt = '') => {
    if (image) {
        return (
            <img alt={alt} style={{maxHeight: '100px', maxWidth: '100px'}}
                 src={image}
            />
        );
    }
};

export const checkboxFormatter = (cell, row, fieldName, onCheck) => {
    if (cell) {
        return (
            <Checkbox onCheck={() => {}} label='' checked disabled />
        );
    } else if (!cell && row) {
        return (
            <Checkbox onCheck={onCheck} label='' checked={row[`request_${fieldName}`]} />
        );
    } else return null;
};

export const dateFormatter = cell => {
    return cell ? moment(cell).format(DATE_FORMAT) : '';
};

export const colorBadgeFormatter = (cell, row) => {
    if (cell && row && !row.color) {
        return cell;
    }
    if (cell && row.color) {
        return <h5><Badge color='none' style={{backgroundColor: `${row.color}`}} pill>{cell}</Badge></h5>;
    }
};

export const arrayConcatFormatter = cell => {
    return cell ? cell.map(c =>
        <div key={Math.random()}>
            {c.name ? c.name : c.label}
        </div>,
    ) : '';
};

export const dateTimeFormatter = cell => {
    return cell ? moment(cell).format(DATE_TIME_FORMAT) : '';
};

export const percentFormatter = cell => {
    return cell ? cell + '%' : '';
};

export const inchFormatter = cell => {
    return cell ? cell + ' "' : cell;
};

export const bfFormatter = cell => {
    return cell ? cell + ' bf' : cell;
};

export const numberFormatter = cell => {
    return Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(cell);
};

export const dollarsFormatter = cell => {
    return cell ? <Dollars amount={+cell} /> : '';
};
export const impactFormatter = cell => {
    return cell ? cell + ' MT CO2e' : '-- MT CO2e';
};
export const discountFormatter = (discounted_price, base_price) => {

    if (discounted_price && discounted_price !== base_price) {
        return (<div className='cart-discount'>
            <span className='base_price'>{dollarsFormatter(base_price)}</span>
            <span className='discounted-price'>{dollarsFormatter(discounted_price)}</span>
        </div>);
    } else {
        return (<div className='cart-discount'>
            <span className='price'>{dollarsFormatter(base_price)}</span>
        </div>);
    }


};
export const percentage = (value1, value2) => {
    if (value1 > 0) {
        return ((value2 - value1) / value2 * 100).toFixed(0) + '%';
    } else {
        return '100%';
    }
};

export const addBooleanIcons = cell => {
    return cell ?
        <FontAwesomeIcon className='text-success ml-4' icon={faCheckSquare} /> :
        <FontAwesomeIcon className='text-warning ml-4' icon={faWindowClose} />;
};


export const addFahrenheit = cell => {
    return cell ? cell + '℉' : '';
};

export const countAverage = row => {
    let sum = 0;
    let counter = 0;
    if (row.probe1) {
        sum += parseInt(row.probe1);
        counter++;
    }
    if (row.probe2) {
        sum += parseInt(row.probe2);
        counter++;
    }
    if (row.probe3) {
        sum += parseInt(row.probe3);
        counter++;
    }
    if (row.probe4) {
        sum += parseInt(row.probe4);
        counter++;
    }
    return (sum / counter) + '%';
};


// WEBPACK FOOTER //
// ./src/common/TableFormatters.js